import { useEffect } from 'react'
import HeadMeta from 'components/common/HeadMeta'
import JsonLd, { peachjohnPageMeta, peachjohnSchema } from 'components/common/schema'
import Template from 'components/cases/peachjohn'

const Peachjohn: React.FC = () => {
  useEffect(() => {
    document.querySelector('body').classList.add('non-chat')
  }, [])
  return (
    <>
      <HeadMeta {...peachjohnPageMeta} />
      <JsonLd data={peachjohnSchema} />
      <Template />
    </>
  )
}

export default Peachjohn
